/*
  Teedum (11/10/2026) : adresses e-mail jetables (yopmail, herclan…) refusées à l'inscription.
  Formulaires concernés : fenêtre « 10 € offerts » (app Shopify Forms, rendue dans un shadow DOM ouvert) et formulaire newsletter
  du pied de page. Quand le visiteur a fini de taper son adresse, seul son DOMAINE (jamais l'adresse) est vérifié auprès de
  disposable.debounce.io ; s'il est jetable, un message s'affiche sous le champ et l'envoi est bloqué.
  Si le service ne répond pas en 3 s, l'inscription passe : le flux Shopify Flow « Accueillir les nouveaux abonnés » refait la
  vérification et ne crée pas de code de bienvenue pour une adresse jetable. Chargé par layout/theme.liquid.
*/
(function () {
  if (window.teedumDisposableEmail) return;
  window.teedumDisposableEmail = true;

  var KNOWN = ['yopmail.com', 'yopmail.fr', 'yopmail.net', 'mailinator.com', 'guerrillamail.com', 'sharklasers.com', '10minutemail.com', 'temp-mail.org', 'tempmail.com', 'trashmail.com', 'getnada.com', 'maildrop.cc', 'dispostable.com', 'jetable.org', 'herclan.com', 'npo2.com', 'futurejs.com', 'dawhe.com', 'blobapps.com', 'comzx.com'];
  var MESSAGES = {
    fr: 'Cette adresse e-mail est temporaire (jetable). Merci d’utiliser votre adresse habituelle pour recevoir votre code.',
    en: 'This is a temporary (disposable) email address. Please use your usual email address to receive your code.',
    de: 'Dies ist eine temporäre Wegwerf-E-Mail-Adresse. Bitte verwenden Sie Ihre übliche E-Mail-Adresse, um Ihren Code zu erhalten.',
    es: 'Esta dirección de correo es temporal (desechable). Utiliza tu dirección habitual para recibir tu código.',
    it: 'Questo indirizzo e-mail è temporaneo (usa e getta). Usa il tuo indirizzo abituale per ricevere il codice.'
  };
  var message = MESSAGES[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MESSAGES.fr;
  var verdicts = {};
  var bypass = false;

  function domainOf(value) {
    var match = /^[^\s@]+@([^\s@]+\.[^\s@]+)$/.exec((value || '').trim().toLowerCase());
    return match ? match[1] : '';
  }

  // true (jetable), false, une promesse en cours, ou undefined (jamais vérifié)
  function lookup(domain) {
    return KNOWN.indexOf(domain) !== -1 ? true : verdicts[domain];
  }

  function check(domain) {
    var known = lookup(domain);
    if (known !== undefined) return Promise.resolve(known);
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 3000);
    var request = fetch('https://disposable.debounce.io/?email=' + encodeURIComponent('verification@' + domain), controller ? { signal: controller.signal } : undefined)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        clearTimeout(timer);
        verdicts[domain] = String(data && data.disposable) === 'true';
        return verdicts[domain];
      })
      .catch(function () {
        clearTimeout(timer);
        delete verdicts[domain];
        return false;
      });
    verdicts[domain] = request;
    return request;
  }

  function setError(field, disposable) {
    var note = field.anchor.nextElementSibling;
    if (!note || !note.hasAttribute('data-teedum-disposable')) note = null;
    if (disposable) {
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-teedum-disposable', '');
        note.setAttribute('role', 'alert');
        note.style.cssText = 'margin:' + field.margin + ';color:' + field.color + ';font-size:14px;line-height:1.35;text-align:start;';
        field.anchor.insertAdjacentElement('afterend', note);
      }
      note.textContent = message;
    } else if (note) {
      note.remove();
    }
    field.input.setAttribute('aria-invalid', disposable ? 'true' : 'false');
  }

  function validate(field) {
    var domain = domainOf(field.input.value);
    if (!domain) {
      setError(field, false);
      return;
    }
    check(domain).then(function (disposable) {
      if (domainOf(field.input.value) === domain) setError(field, disposable);
    });
  }

  function guard(event, field, submitter) {
    if (bypass) return;
    var domain = domainOf(field.input.value);
    if (!domain) return;
    var verdict = lookup(domain);
    if (verdict === false) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (verdict === true) {
      setError(field, true);
      return;
    }
    check(domain).then(function (disposable) {
      if (disposable) {
        setError(field, true);
        return;
      }
      bypass = true;
      try { field.resubmit(submitter); } finally { bypass = false; }
    });
  }

  // Fenêtre Shopify Forms : champ #email, bouton type submit, erreur affichée sous le conteneur du champ (comme celles de l'app)
  function describeShopifyForm(form) {
    var input = form && form.querySelector('#email, input[inputmode="email"], input[type="email"]');
    if (!input) return null;
    return {
      input: input,
      anchor: input.parentElement,
      color: 'rgb(175, 22, 29)',
      margin: '0',
      resubmit: function () {
        var button = form.querySelector('button[type="submit"]');
        if (button) button.click();
        else if (form.requestSubmit) form.requestSubmit();
      }
    };
  }

  // Formulaire newsletter du thème (pied de page) : formulaire « customer » avec contact[tags]
  function describeNewsletter(form) {
    if (!form || !form.querySelector('input[name="contact[tags]"]')) return null;
    var input = form.querySelector('input[name="contact[email]"]');
    if (!input) return null;
    return {
      input: input,
      anchor: form,
      color: 'inherit',
      margin: '.5rem 0 0',
      resubmit: function (submitter) {
        if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
        else form.submit();
      }
    };
  }

  function formOf(target) {
    if (!target || !target.closest) return null;
    return target.form || target.closest('form');
  }

  function watch(root, describe) {
    var timer;
    root.addEventListener('input', function (event) {
      var field = describe(formOf(event.target));
      if (!field || event.target !== field.input) return;
      setError(field, false);
      clearTimeout(timer);
      timer = setTimeout(function () { validate(field); }, 700);
    }, true);
    root.addEventListener('focusout', function (event) {
      var field = describe(formOf(event.target));
      if (field && event.target === field.input) validate(field);
    }, true);
    root.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('button[type="submit"], input[type="submit"]');
      var field = button && describe(formOf(button));
      if (field) guard(event, field, button);
    }, true);
    root.addEventListener('submit', function (event) {
      var field = describe(event.target);
      if (field) guard(event, field, event.submitter);
    }, true);
  }

  watch(document, describeNewsletter);

  function hookShopifyForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      if (!host.shadowRoot || host.hasAttribute('data-teedum-disposable')) return;
      host.setAttribute('data-teedum-disposable', '');
      watch(host.shadowRoot, describeShopifyForm);
    });
  }

  // L'app ajoute son élément après le chargement de la page : on regarde chaque seconde pendant 30 s
  var tries = 0;
  var poll = setInterval(function () {
    hookShopifyForms();
    if (++tries >= 30) clearInterval(poll);
  }, 1000);
  hookShopifyForms();
})();
